const resource = 'order_variants'

export default $axios => ({
  delete(id) {
    return $axios.$delete(`/${resource}/${id}`)
  },
  update(id, params) {
    return $axios.$put(`/${resource}/${id}`, params)
  },
  create(params) {
    return $axios.$post(`/${resource}/`, params)
  },
  getServiceName: name => 'orderProductService',
})
